module.exports = __webpack_public_path__ + "img/1388499337.aeb2ef50.jpg";